const AUTHORING_PREFIX = '/agent/expert/authoring'

/** 저작 프로그램 종류 — 치유(healing_*) / 인문(humanities_*) */
export const PROGRAM_KINDS = {
  healing: {
    label: '치유 프로그램',
    programPath: `${AUTHORING_PREFIX}/program`,
    activitiesPath: `${AUTHORING_PREFIX}/program/activities`,
    programApi: '/api/healing-programs',
    activitiesApi: '/api/healing-activities',
  },
  humanities: {
    label: '인문 프로그램',
    programPath: `${AUTHORING_PREFIX}/humanities/program`,
    activitiesPath: `${AUTHORING_PREFIX}/humanities/activities`,
    programApi: '/api/humanities-programs',
    activitiesApi: '/api/humanities-activities',
  },
}

export const CONTENTS_PATH = `${AUTHORING_PREFIX}/humanities/contents`

export function programKindConfig(kind) {
  return PROGRAM_KINDS[kind] ?? PROGRAM_KINDS.healing
}
